import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, withDefaults } from 'vue';

interface Props {
    description?: string;
    variant?: 'normal' | 'warning';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CombinationsStepInfo',
  props: {
    description: { default: '' },
    variant: { default: 'normal' }
  },
  setup(__props: any) {

const props = __props as { description: string, variant: 'normal' | 'warning' };



const { proxy } = getCurrentInstance()!;

const formattedDescription = computed<string>(() => {
    const translated = proxy.$t(props.description) as string;
    // Replace newlines with <br> tags to create line breaks
    return translated.replace(/\n/g, '<br>');
});

return { __sfc: true,props, proxy, formattedDescription }
}

})